var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 59,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, Helvetica, sans-serif",
    fontSize: 24,
    fontWeight: 800,
    letterSpacing: "-0.03em",
    fill: "white"
  }, "CLEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClew);
export default __webpack_public_path__ + "static/media/clew.b4388d613c5bf0ce82e315fd125cfc53.svg";
export { ForwardRef as ReactComponent };